module.exports = __webpack_public_path__ + "static/architecture-ad2e4e33d4c0591f0bb5601fa227e28b.svg";